import { ApiError } from '@/lib/api';

// The checkout a guest walked away from — or one a provider refused — and where
// they may pick it up. Both the venue page and the booking-code screen read it,
// because a payment can fail on either side of the redirect. §13
export function pendingCheckout(error: unknown): { payUrl: string | null } | null {
  if (!(error instanceof ApiError)) return null;
  const body = error.body as { reason?: string; payUrl?: string | null } | null;
  if (body?.reason !== 'awaiting-payment') return null;
  return { payUrl: body.payUrl ?? null };
}
